import React from "react";
import styles from "./ToastContainer.module.css";
import { MdErrorOutline, MdCheckCircleOutline, MdInfoOutline } from "react-icons/md";

const ToastContainer = ({ toasts, removeToast }) => {
  return (
    <div className={styles.toastWrapper}>
      {toasts.map((toast) => {
        let Icon = MdInfoOutline;
        let toastClass = styles.info;

        if (toast.type === "error") {
          Icon = MdErrorOutline;
          toastClass = styles.error;
        } else if (toast.type === "success") {
          Icon = MdCheckCircleOutline;
          toastClass = styles.success;
        }

        return (
          <div key={toast.id} className={`${styles.toast} ${toastClass}`} onClick={() => removeToast(toast.id)}>
            <div className={styles.iconWrapper}>
              <Icon size="24" />
            </div>
            <div className={styles.message}>{toast.message}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ToastContainer;
